module.exports = __webpack_public_path__ + "static/map2.19c020a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/img/map2.png
// module id = 582
// module chunks = 213534597649335